module.exports = __webpack_public_path__ + "img/img_download.6cb3b918.png";